let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gHixD")).then(() => parcelRequire('6rSut'));